
<div class="dash-grid--item full-width module drop-shadow bottom">
    <div class="dashboard--module-header">
        <h2 class="subheading-md">Select when <button class="info-btn focus-element" (click)="onTitleInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
    </div>
    <form class="module--main module--main__column" [formGroup]="form" (submit)="submitForm(form)" autocomplete="off">
        <div class="row u-width__full">
            <div class="col-md-2 col-sm-2 col-xs-12">
                <div class="form-group">
                    <div class="radio"> <input type="radio" id="radio-one" [formControl]="form.controls['isScheduled']" [value]="false" (change)="changeType()" name="radio-group"><label for="radio-one"><div class="check"></div>Now</label></div>
                    <div class="radio"> <input type="radio" id="radio-two" [formControl]="form.controls['isScheduled']" [value]="true" (change)="changeType()" name="radio-group"><label for="radio-two"><div class="check"></div>Schedule for later</label></div>
                </div>
            </div>
            <div class="col-md-8 col-sm-8 col-xs-12">
                <div class="c-datepicker">
                    <div class="c-datepicker__controls">
                        <button type="button" class="c-datepicker__controls__button" (click)="prevMonth(1)">
                            <span class="focus--content" tabindex="-1">
                                <svg class="m-ic m-ic--xs m-ic--arrow m-ic--arrow-left"><use xlink:href="#ic-arrow" href="#ic-arrow"></use></svg>
                            </span>
                        </button>
                        <div class="c-datepicker__controls__date">
                            <select class="c-datepicker__controls__select c-form__select" style="width: auto;" [formControl]="form.controls['datePicker1_Month']">
                                <option *ngFor="let item of monthNames; let i = index" [value]="i" (click)="selectDate(1, i)">{{item}}</option>
                            </select>
                            <select class="c-datepicker__controls__select c-form__select" style="width: auto;" [formControl]="form.controls['datePicker1_Year']">
                                <option *ngFor="let item of years" [value]="item">{{item}}</option>
                            </select>
                        </div>
                        <button type="button" class="c-datepicker__controls__button focus-element" (click)="nextMonth(1)">
                            <span class="focus--content" tabindex="-1">
                                <svg class="m-ic m-ic--xs m-ic--arrow m-ic--arrow-right"><use xlink:href="#ic-arrow" href="#ic-arrow"></use></svg>
                            </span>
                        </button>
                    </div>
                    <div>
                        <ul class="c-datepicker__weekdays">
                            <li *ngFor="let day of dayNames; let i = index;">{{day}}</li>
                        </ul>
                        <ul class="c-datepicker__days-list">
                            <li *ngFor="let item of datePicker1_Days; let i = index;">
                                <button type="button" class="c-datepicker__day focus-element"
                                        [disabled]="!item.isSelectable || !item.inThisMonth"
                                        [ngClass]="{ 'h-fade': !item.inThisMonth || !item.isSelectable , 'c-datepicker__day--selected': item.isSelected}"
                                        (click)="item.isSelectable && selectDate(1, i)">
                                    <span class="focus--content" tabindex="-1"><span class="u-absolute-center">{{item.day}}</span></span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-2 col-sm-2 col-xs-12">
                <div class="form-group">
                    <label for="time">Time</label>
                    <input id="time" type='text' [textMask]="{mask: mask, guide: false}" [formControl]="form.controls['dateTime']">
                </div>
                <div class="form-group danger" *ngIf="submitted">
                    <span *ngIf="form.controls['dateTime'].hasError('required')" class="validation-msg">Time is required*</span>
                </div>
            </div>
        </div>
        <p *ngIf="!selectedDate && !selectedDate.dateFrom" class="text-center u-spacing--large"><span class="lg">Please select a date</span></p>
        <p *ngIf="selectedDate && selectedDate.dateFrom" class="text-center u-spacing--large">This interaction will be scheduled for: <span class="lg">{{selectedDate.dateFrom | date: 'EEEE d LLLL yyyy HH:mm'}}</span></p>
        <button class="std-btn focus-element" type="submit"><span class="focus--content" tabindex="-1">Next</span></button>
    </form>
    <br>
    <br>
    <br>
</div>

